import React from "react";

/**
 * Always use this component to render the FauzyLogic brand name.
 * Fauzy = fauzylogic blue, Logic = fauzylogic orange.
 */
export const FauzyLogic: React.FC = () => (
  <span>
    <span className="text-fauzy-blue">Fauzy</span>
    <span className="text-fauzy-orange">Logic</span>
  </span>
);

export default FauzyLogic;
